import Vue from 'vue'
import Router from 'vue-router'
import { defaultLocale } from '../config/i18n'
// import Main from "@/components/Main";
// import LoginPage from '@/components/Auth/Login'
// import RegisterPage from '@/components/Auth/Register'
// import ProfilePage from '@/components/Profile/Profile'
// import RememberPage from '@/components/Auth/Remember'
// import ChangePage from '@/components/Auth/ChangePage'
// import ServicePage from '@/components/Serwisowy'

import HomePage from '@/components/HomePage'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      redirect: `/${defaultLocale}`
    },
    {
      path: '/:locale',
      name: 'ContentPage',
      component: HomePage,
      props: true
      // beforeEnter: (to, from, next) => {
      //   if (Object.keys(this.$i18n.messages).indexOf(to.params.locale) === -1) {
      //     to.params.locale = 'en'
      //   }
      //   next()
      // }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js